// Section 13 and 18 (stream M4a), 24.14 actions: the justice policy, the guard mandate and the
// per-case answers to "ask each case". Allowed only while deciding (24.7). Policy edits are
// changes relative to the committed state, so an unchanged value is dropped from the draft; a
// case answer goes into the draft's `eventChoices` ({ kind: 'justice', response }) and is applied
// by the crime phase at the start of next season's crime resolution.
import type { GuardMandateOption, JusticeResponse, PromptId } from '../../sim/api';
import { withBoundary } from '../boundary';
import { requireGame } from '../guards';
import { editDraft } from './decision';

export const setJusticePolicy = withBoundary(
  (response: JusticeResponse, askEachCase: boolean): void => {
    const state = requireGame();
    editDraft((d) => {
      const policies = { ...d.policies };
      const now = state.policies.justice;
      if (now.response === response && now.askEachCase === askEachCase) delete policies.justice;
      else policies.justice = { response, askEachCase };
      return { ...d, policies };
    });
  },
);

export const setGuardMandate = withBoundary((mandate: GuardMandateOption): void => {
  const state = requireGame();
  editDraft((d) => {
    const policies = { ...d.policies };
    if (state.policies.guardMandate === mandate) delete policies.guardMandate;
    else policies.guardMandate = mandate;
    return { ...d, policies };
  });
});

/** Answer an open justice prompt (the case screen's override); the prompt must be open. */
export const answerJustice = withBoundary((promptId: PromptId, response: JusticeResponse): void => {
  const state = requireGame();
  const prompt = state.openPrompts.find((p) => p.id === promptId);
  if (prompt?.kind !== 'justice') return;
  editDraft((d) => ({
    ...d,
    eventChoices: { ...d.eventChoices, [promptId]: { kind: 'justice', response } },
  }));
});
